import React from "react";
import { Button, Divider, Form, Input, Select, DatePicker } from "antd";
import { m } from "framer-motion";
import dayjs from "dayjs";

const RecruitmentTrackerFilter = ({
  filterData,
  setFilterData,
  getData,
  toggleFilterModal,
  loading,
  createdBy,
  createdByFetching,
}) => {
  const [form] = Form.useForm();

  const nation = [
    {
      id: 1,
      label: "Afghanistan",
      value: "Afghanistan",
    },
    {
      id: 2,
      label: "Aland Islands",
      value: "Aland Islands",
    },
    {
      id: 3,
      label: "Albania",
      value: "Albania",
    },
    {
      id: 4,
      label: "Algeria",
      value: "Algeria",
    },
    {
      id: 5,
      label: "American Samoa",
      value: "American Samoa",
    },
    {
      id: 6,
      label: "Andorra",
      value: "Andorra",
    },
    {
      id: 7,
      label: "Angola",
      value: "Angola",
    },
    {
      id: 8,
      label: "Anguilla",
      value: "Anguilla",
    },
    {
      id: 9,
      label: "Antarctica",
      value: "Antarctica",
    },
    {
      id: 10,
      label: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
    },
    {
      id: 11,
      label: "Argentina",
      value: "Argentina",
    },
    {
      id: 12,
      label: "Armenia",
      value: "Armenia",
    },
    {
      id: 13,
      label: "Aruba",
      value: "Aruba",
    },
    {
      id: 14,
      label: "Australia",
      value: "Australia",
    },
    {
      id: 15,
      label: "Austria",
      value: "Austria",
    },
    {
      id: 16,
      label: "Azerbaijan",
      value: "Azerbaijan",
    },
    {
      id: 17,
      label: "Bahamas",
      value: "Bahamas",
    },
    {
      id: 18,
      label: "Bahrain",
      value: "Bahrain",
    },
    {
      id: 19,
      label: "Bangladesh",
      value: "Bangladesh",
    },
    {
      id: 20,
      label: "Barbados",
      value: "Barbados",
    },
    {
      id: 21,
      label: "Belarus",
      value: "Belarus",
    },
    {
      id: 22,
      label: "Belgium",
      value: "Belgium",
    },
    {
      id: 23,
      label: "Belize",
      value: "Belize",
    },
    {
      id: 24,
      label: "Benin",
      value: "Benin",
    },
    {
      id: 25,
      label: "Bermuda",
      value: "Bermuda",
    },
    {
      id: 26,
      label: "Bhutan",
      value: "Bhutan",
    },
    {
      id: 27,
      label: "Bolivia (Plurinational State of)",
      value: "Bolivia (Plurinational State of)",
    },
    {
      id: 28,
      label: "Bonaire",
      value: "Bonaire",
    },
    {
      id: 29,
      label: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
    },
    {
      id: 30,
      label: "Botswana",
      value: "Botswana",
    },
    {
      id: 31,
      label: "Bouvet Island",
      value: "Bouvet Island",
    },
    {
      id: 32,
      label: "Brazil",
      value: "Brazil",
    },
    {
      id: 33,
      label: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
    },
    {
      id: 34,
      label: "Brunei Darussalam",
      value: "Brunei Darussalam",
    },
    {
      id: 35,
      label: "Bulgaria",
      value: "Bulgaria",
    },
    {
      id: 36,
      label: "Burkina Faso",
      value: "Burkina Faso",
    },
    {
      id: 37,
      label: "Burundi",
      value: "Burundi",
    },
    {
      id: 38,
      label: "Cabo Verde",
      value: "Cabo Verde",
    },
    {
      id: 39,
      label: "Cambodia",
      value: "Cambodia",
    },
    {
      id: 40,
      label: "Cameroon",
      value: "Cameroon",
    },
    {
      id: 41,
      label: "Canada",
      value: "Canada",
    },
    {
      id: 42,
      label: "Cayman Islands",
      value: "Cayman Islands",
    },
    {
      id: 43,
      label: "Central African Republic",
      value: "Central African Republic",
    },
    {
      id: 44,
      label: "Chad",
      value: "Chad",
    },
    {
      id: 45,
      label: "Chile",
      value: "Chile",
    },
    {
      id: 46,
      label: "China",
      value: "China",
    },
    {
      id: 47,
      label: "Christmas Island",
      value: "Christmas Island",
    },
    {
      id: 48,
      label: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
    },
    {
      id: 49,
      label: "Colombia",
      value: "Colombia",
    },
    {
      id: 50,
      label: "Comoros",
      value: "Comoros",
    },
    {
      id: 51,
      label: "Congo (Republic of the)",
      value: "Congo (Republic of the)",
    },
    {
      id: 52,
      label: "Congo (Democratic Republic of the)",
      value: "Congo (Democratic Republic of the)",
    },
    {
      id: 53,
      label: "Cook Islands",
      value: "Cook Islands",
    },
    {
      id: 54,
      label: "Costa Rica",
      value: "Costa Rica",
    },
    {
      id: 55,
      label: "Cote dIvoire",
      value: "Cote dIvoire",
    },
    {
      id: 56,
      label: "Croatia",
      value: "Croatia",
    },
    {
      id: 57,
      label: "Cuba",
      value: "Cuba",
    },
    {
      id: 58,
      label: "Curacao",
      value: "Curacao",
    },
    {
      id: 59,
      label: "Cyprus",
      value: "Cyprus",
    },
    {
      id: 60,
      label: "Czech Republic",
      value: "Czech Republic",
    },
    {
      id: 61,
      label: "Denmark",
      value: "Denmark",
    },
    {
      id: 62,
      label: "Djibouti",
      value: "Djibouti",
    },
    {
      id: 63,
      label: "Dominica",
      value: "Dominica",
    },
    {
      id: 64,
      label: "Dominican Republic",
      value: "Dominican Republic",
    },
    {
      id: 65,
      label: "Ecuador",
      value: "Ecuador",
    },
    {
      id: 66,
      label: "Egypt",
      value: "Egypt",
    },
    {
      id: 67,
      label: "El Salvador",
      value: "El Salvador",
    },
    {
      id: 68,
      label: "Equatorial Guinea",
      value: "Equatorial Guinea",
    },
    {
      id: 69,
      label: "Eritrea",
      value: "Eritrea",
    },
    {
      id: 70,
      label: "Estonia",
      value: "Estonia",
    },
    {
      id: 71,
      label: "Ethiopia",
      value: "Ethiopia",
    },
    {
      id: 72,
      label: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
    },
    {
      id: 73,
      label: "Faroe Islands",
      value: "Faroe Islands",
    },
    {
      id: 74,
      label: "Fiji",
      value: "Fiji",
    },
    {
      id: 75,
      label: "Finland",
      value: "Finland",
    },
    {
      id: 76,
      label: "France",
      value: "France",
    },
    {
      id: 77,
      label: "French Guiana",
      value: "French Guiana",
    },
    {
      id: 78,
      label: "French Polynesia",
      value: "French Polynesia",
    },
    {
      id: 79,
      label: "French Southern Territories",
      value: "French Southern Territories",
    },
    {
      id: 80,
      label: "Gabon",
      value: "Gabon",
    },
    {
      id: 81,
      label: "Gambia",
      value: "Gambia",
    },
    {
      id: 82,
      label: "Georgia",
      value: "Georgia",
    },
    {
      id: 83,
      label: "Germany",
      value: "Germany",
    },
    {
      id: 84,
      label: "Ghana",
      value: "Ghana",
    },
    {
      id: 85,
      label: "Gibraltar",
      value: "Gibraltar",
    },
    {
      id: 86,
      label: "Greece",
      value: "Greece",
    },
    {
      id: 87,
      label: "Greenland",
      value: "Greenland",
    },
    {
      id: 88,
      label: "Grenada",
      value: "Grenada",
    },
    {
      id: 89,
      label: "Guadeloupe",
      value: "Guadeloupe",
    },
    {
      id: 90,
      label: "Guam",
      value: "Guam",
    },
    {
      id: 91,
      label: "Guatemala",
      value: "Guatemala",
    },
    {
      id: 92,
      label: "Guernsey",
      value: "Guernsey",
    },
    {
      id: 93,
      label: "Guinea",
      value: "Guinea",
    },
    {
      id: 94,
      label: "Guinea-Bissau",
      value: "Guinea-Bissau",
    },
    {
      id: 95,
      label: "Guyana",
      value: "Guyana",
    },
    {
      id: 96,
      label: "Haiti",
      value: "Haiti",
    },
    {
      id: 97,
      label: "Heard Island and McDonald Islands",
      value: "Heard Island and McDonald Islands",
    },
    {
      id: 98,
      label: "Vatican City State",
      value: "Vatican City State",
    },
    {
      id: 99,
      label: "Honduras",
      value: "Honduras",
    },
    {
      id: 100,
      label: "Hong Kong",
      value: "Hong Kong",
    },
    {
      id: 101,
      label: "Hungary",
      value: "Hungary",
    },
    {
      id: 102,
      label: "Iceland",
      value: "Iceland",
    },
    {
      id: 103,
      label: "India",
      value: "India",
    },
    {
      id: 104,
      label: "Indonesia",
      value: "Indonesia",
    },
    {
      id: 105,
      label: "Iran",
      value: "Iran",
    },
    {
      id: 106,
      label: "Iraq",
      value: "Iraq",
    },
    {
      id: 107,
      label: "Ireland",
      value: "Ireland",
    },
    {
      id: 108,
      label: "Isle of Man",
      value: "Isle of Man",
    },
    {
      id: 109,
      label: "Israel",
      value: "Israel",
    },
    {
      id: 110,
      label: "Italy",
      value: "Italy",
    },
    {
      id: 111,
      label: "Jamaica",
      value: "Jamaica",
    },
    {
      id: 112,
      label: "Japan",
      value: "Japan",
    },
    {
      id: 113,
      label: "Jersey",
      value: "Jersey",
    },
    {
      id: 114,
      label: "Jordan",
      value: "Jordan",
    },
    {
      id: 115,
      label: "Kazakhstan",
      value: "Kazakhstan",
    },
    {
      id: 116,
      label: "Kenya",
      value: "Kenya",
    },
    {
      id: 117,
      label: "Kiribati",
      value: "Kiribati",
    },
    {
      id: 118,
      label: "Korea (Democratic Peoples Republic of)",
      value: "Korea (Democratic Peoples Republic of)",
    },
    {
      id: 119,
      label: "Korea (Republic of)",
      value: "Korea (Republic of)",
    },
    {
      id: 120,
      label: "Kuwait",
      value: "Kuwait",
    },
    {
      id: 121,
      label: "Kyrgyzstan",
      value: "Kyrgyzstan",
    },
    {
      id: 122,
      label: "Lao Peoples Democratic Republic",
      value: "Lao Peoples Democratic Republic",
    },
    {
      id: 123,
      label: "Latvia",
      value: "Latvia",
    },
    {
      id: 124,
      label: "Lebanon",
      value: "Lebanon",
    },
    {
      id: 125,
      label: "Lesotho",
      value: "Lesotho",
    },
    {
      id: 126,
      label: "Liberia",
      value: "Liberia",
    },
    {
      id: 127,
      label: "Libya",
      value: "Libya",
    },
    {
      id: 128,
      label: "Liechtenstein",
      value: "Liechtenstein",
    },
    {
      id: 129,
      label: "Lithuania",
      value: "Lithuania",
    },
    {
      id: 130,
      label: "Luxembourg",
      value: "Luxembourg",
    },
    {
      id: 131,
      label: "Macao",
      value: "Macao",
    },
    {
      id: 132,
      label: "Macedonia (the former Yugoslav Republic of)",
      value: "Macedonia (the former Yugoslav Republic of)",
    },
    {
      id: 133,
      label: "Madagascar",
      value: "Madagascar",
    },
    {
      id: 134,
      label: "Malawi",
      value: "Malawi",
    },
    {
      id: 135,
      label: "Malaysia",
      value: "Malaysia",
    },
    {
      id: 136,
      label: "Maldives",
      value: "Maldives",
    },
    {
      id: 137,
      label: "Mali",
      value: "Mali",
    },
    {
      id: 138,
      label: "Malta",
      value: "Malta",
    },
    {
      id: 139,
      label: "Marshall Islands",
      value: "Marshall Islands",
    },
    {
      id: 140,
      label: "Martinique",
      value: "Martinique",
    },
    {
      id: 141,
      label: "Mauritania",
      value: "Mauritania",
    },
    {
      id: 142,
      label: "Mauritius",
      value: "Mauritius",
    },
    {
      id: 143,
      label: "Mayotte",
      value: "Mayotte",
    },
    {
      id: 144,
      label: "Mexico",
      value: "Mexico",
    },
    {
      id: 145,
      label: "Micronesia (Federated States of)",
      value: "Micronesia (Federated States of)",
    },
    {
      id: 146,
      label: "Moldova (Republic of)",
      value: "Moldova (Republic of)",
    },
    {
      id: 147,
      label: "Monaco",
      value: "Monaco",
    },
    {
      id: 148,
      label: "Mongolia",
      value: "Mongolia",
    },
    {
      id: 149,
      label: "Montenegro",
      value: "Montenegro",
    },
    {
      id: 150,
      label: "Montserrat",
      value: "Montserrat",
    },
    {
      id: 151,
      label: "Morocco",
      value: "Morocco",
    },
    {
      id: 152,
      label: "Mozambique",
      value: "Mozambique",
    },
    {
      id: 153,
      label: "Myanmar",
      value: "Myanmar",
    },
    {
      id: 154,
      label: "Namibia",
      value: "Namibia",
    },
    {
      id: 155,
      label: "Nauru",
      value: "Nauru",
    },
    {
      id: 156,
      label: "Nepal",
      value: "Nepal",
    },
    {
      id: 157,
      label: "Netherlands",
      value: "Netherlands",
    },
    {
      id: 158,
      label: "New Caledonia",
      value: "New Caledonia",
    },
    {
      id: 159,
      label: "New Zealand",
      value: "New Zealand",
    },
    {
      id: 160,
      label: "Nicaragua",
      value: "Nicaragua",
    },
    {
      id: 161,
      label: "Niger",
      value: "Niger",
    },
    {
      id: 162,
      label: "Nigeria",
      value: "Nigeria",
    },
    {
      id: 163,
      label: "Niue",
      value: "Niue",
    },
    {
      id: 164,
      label: "Norfolk Island",
      value: "Norfolk Island",
    },
    {
      id: 165,
      label: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
    },
    {
      id: 166,
      label: "Norway",
      value: "Norway",
    },
    {
      id: 167,
      label: "Oman",
      value: "Oman",
    },
    {
      id: 168,
      label: "Pakistan",
      value: "Pakistan",
    },
    {
      id: 169,
      label: "Palau",
      value: "Palau",
    },
    {
      id: 170,
      label: "Palestine",
      value: "Palestine",
    },
    {
      id: 171,
      label: "Panama",
      value: "Panama",
    },
    {
      id: 172,
      label: "Papua New Guinea",
      value: "Papua New Guinea",
    },
    {
      id: 173,
      label: "Paraguay",
      value: "Paraguay",
    },
    {
      id: 174,
      label: "Peru",
      value: "Peru",
    },
    {
      id: 175,
      label: "Philippines",
      value: "Philippines",
    },
    {
      id: 176,
      label: "Pitcairn",
      value: "Pitcairn",
    },
    {
      id: 177,
      label: "Poland",
      value: "Poland",
    },
    {
      id: 178,
      label: "Portugal",
      value: "Portugal",
    },
    {
      id: 179,
      label: "Puerto Rico",
      value: "Puerto Rico",
    },
    {
      id: 180,
      label: "Qatar",
      value: "Qatar",
    },
    {
      id: 181,
      label: "Reunion",
      value: "Reunion",
    },
    {
      id: 182,
      label: "Romania",
      value: "Romania",
    },
    {
      id: 183,
      label: "Russian Federation",
      value: "Russian Federation",
    },
    {
      id: 184,
      label: "Rwanda",
      value: "Rwanda",
    },
    {
      id: 185,
      label: "Saint Barthelemy",
      value: "Saint Barthelemy",
    },
    {
      id: 186,
      label: "Saint Helena",
      value: "Saint Helena",
    },
    {
      id: 187,
      label: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
    },
    {
      id: 188,
      label: "Saint Lucia",
      value: "Saint Lucia",
    },
    {
      id: 189,
      label: "Saint Martin (French part)",
      value: "Saint Martin (French part)",
    },
    {
      id: 190,
      label: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
    },
    {
      id: 191,
      label: "Saint Vincent and the Grenadines",
      value: "Saint Vincent and the Grenadines",
    },
    {
      id: 192,
      label: "Samoa",
      value: "Samoa",
    },
    {
      id: 193,
      label: "San Marino",
      value: "San Marino",
    },
    {
      id: 194,
      label: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
    },
    {
      id: 195,
      label: "Saudi Arabia",
      value: "Saudi Arabia",
    },
    {
      id: 196,
      label: "Senegal",
      value: "Senegal",
    },
    {
      id: 197,
      label: "Serbia",
      value: "Serbia",
    },
    {
      id: 198,
      label: "Seychelles",
      value: "Seychelles",
    },
    {
      id: 199,
      label: "Sierra Leone",
      value: "Sierra Leone",
    },
    {
      id: 200,
      label: "Singapore",
      value: "Singapore",
    },
    {
      id: 201,
      label: "Sint Maarten (Dutch part)",
      value: "Sint Maarten (Dutch part)",
    },
    {
      id: 202,
      label: "Slovakia",
      value: "Slovakia",
    },
    {
      id: 203,
      label: "Slovenia",
      value: "Slovenia",
    },
    {
      id: 204,
      label: "Solomon Islands",
      value: "Solomon Islands",
    },
    {
      id: 205,
      label: "Somalia",
      value: "Somalia",
    },
    {
      id: 206,
      label: "South Africa",
      value: "South Africa",
    },
    {
      id: 207,
      label: "South Georgia and the South Sandwich Islands",
      value: "South Georgia and the South Sandwich Islands",
    },
    {
      id: 208,
      label: "South Sudan",
      value: "South Sudan",
    },
    {
      id: 209,
      label: "Spain",
      value: "Spain",
    },
    {
      id: 210,
      label: "Sri Lanka",
      value: "Sri Lanka",
    },
    {
      id: 211,
      label: "Sudan",
      value: "Sudan",
    },
    {
      id: 212,
      label: "Suriname",
      value: "Suriname",
    },
    {
      id: 213,
      label: "Svalbard and Jan Mayen",
      value: "Svalbard and Jan Mayen",
    },
    {
      id: 214,
      label: "Swaziland",
      value: "Swaziland",
    },
    {
      id: 215,
      label: "Sweden",
      value: "Sweden",
    },
    {
      id: 216,
      label: "Switzerland",
      value: "Switzerland",
    },
    {
      id: 217,
      label: "Syrian Arab Republic",
      value: "Syrian Arab Republic",
    },
    {
      id: 218,
      label: "Taiwan",
      value: "Taiwan",
    },
    {
      id: 219,
      label: "Tajikistan",
      value: "Tajikistan",
    },
    {
      id: 220,
      label: "Tanzania",
      value: "Tanzania",
    },
    {
      id: 221,
      label: "Thailand",
      value: "Thailand",
    },
    {
      id: 222,
      label: "Timor-Leste",
      value: "Timor-Leste",
    },
    {
      id: 223,
      label: "Togo",
      value: "Togo",
    },
    {
      id: 224,
      label: "Tokelau",
      value: "Tokelau",
    },
    {
      id: 225,
      label: "Tonga",
      value: "Tonga",
    },
    {
      id: 226,
      label: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
    },
    {
      id: 227,
      label: "Tunisia",
      value: "Tunisia",
    },
    {
      id: 228,
      label: "Turkey",
      value: "Turkey",
    },
    {
      id: 229,
      label: "Turkmenistan",
      value: "Turkmenistan",
    },
    {
      id: 230,
      label: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
    },
    {
      id: 231,
      label: "Tuvalu",
      value: "Tuvalu",
    },
    {
      id: 232,
      label: "Uganda",
      value: "Uganda",
    },
    {
      id: 233,
      label: "Ukraine",
      value: "Ukraine",
    },
    {
      id: 234,
      label: "United Arab Emirates",
      value: "United Arab Emirates",
    },
    {
      id: 235,
      label: "United Kingdom of Great Britain and Northern Ireland",
      value: "United Kingdom of Great Britain and Northern Ireland",
    },
    {
      id: 236,
      label: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
    },
    {
      id: 237,
      label: "United States of America",
      value: "United States of America",
    },
    {
      id: 238,
      label: "Uruguay",
      value: "Uruguay",
    },
    {
      id: 239,
      label: "Uzbekistan",
      value: "Uzbekistan",
    },
    {
      id: 240,
      label: "Vanuatu",
      value: "Vanuatu",
    },
    {
      id: 241,
      label: "Venezuela (Bolivarian Republic of)",
      value: "Venezuela (Bolivarian Republic of)",
    },
    {
      id: 242,
      label: "Vietnam",
      value: "Vietnam",
    },
    {
      id: 243,
      label: "Virgin Islands (British)",
      value: "Virgin Islands (British)",
    },
    {
      id: 244,
      label: "Virgin Islands (U.S.)",
      value: "Virgin Islands (U.S.)",
    },
    {
      id: 245,
      label: "Wallis and Futuna",
      value: "Wallis and Futuna",
    },
    {
      id: 246,
      label: "Western Sahara",
      value: "Western Sahara",
    },
    {
      id: 247,
      label: "Yemen",
      value: "Yemen",
    },
    {
      id: 248,
      label: "Zambia",
      value: "Zambia",
    },
    {
      id: 249,
      label: "Zimbabwe",
      value: "Zimbabwe",
    },
  ];

  const status = [
    {
      id: 1,
      label: "shotlisted",
      value: "shortlisted",
    },
    {
      id: 2,
      label: "not shortlisted",
      value: "not shortlisted",
    },
  ];

  const gender = [
    {
      id: 1,
      label: "Male",
      value: "Male",
    },
    {
      id: 2,
      label: "Female",
      value: "Female",
    },
    {
      id: 3,
      label: "Others",
      value: "Others",
    },
  ];

  const MaritalStatus = [
    {
      id: 1,
      label: "Single",
      value: "Single",
    },
    {
      id: 2,
      label: "Married",
      value: "Married",
    },
    {
      id: 3,
      label: "Widowed",
      value: "Widowed",
    },
    {
      id: 4,
      label: "Divorced",
      value: "Divorced",
    },
    {
      id: 5,
      label: "Separated",
      value: "Separated",
    },
  ];

  const item = {
    hidden: {
      opacity: 0,
      y: "100px",
    },
    show: {
      opacity: 1,
      y: "0px",
      delay: 1,
      transition: {
        type: "spring",
        stiffness: 40,
        damping: 9,
      },
    },
  };

  const handleSearching = async (values) => {
    getData({
      search: filterData.search,
      createdBy: values?.createdBy || "",
      Name: values?.Name || "",
      Nationality: values?.Nationality || "",
      dob: values?.dob ? dayjs(values?.dob).format("YYYY-MM-DD") : "",
      PositionAppliedFor: values?.PositionAppliedFor || "",
      Gender: values?.Gender || "",
      MaritalStatus: values?.MaritalStatus || "",
      Status: values?.Status || "",
    });
    setFilterData({
      search: filterData.search,
      createdBy: values?.createdBy || "",
      Name: values?.Name || "",
      Nationality: values?.Nationality || "",
      dob: values?.dob ? dayjs(values?.dob).format("YYYY-MM-DD") : "",
      PositionAppliedFor: values?.PositionAppliedFor || "",
      Gender: values?.Gender || "",
      MaritalStatus: values?.MaritalStatus || "",
      Status: values?.Status || "",
    });
  };

  return (
    <m.div
      variants={item}
      initial="hidden"
      animate="show"
      exit={{
        opacity: 0,
        scale: 0.9,
      }}
    >
      <Form
        layout="vertical"
        className="filter-box"
        onFinish={handleSearching}
        form={form}
        scrollToFirstError={true}
        initialValues={{
          candidate: filterData?.candidate || null,
          client: filterData?.client || null,
          job: filterData?.job || null,
          interview: filterData?.interview || "",
        }}
      >
        <div className="filter-box-inner">
          <Form.Item name="createdBy" label={"createdBy"}>
            <Select
              placeholder={"createdBy"}
              options={createdBy}
              loading={createdByFetching}
              disabled={createdByFetching}
              allowClear
            />
          </Form.Item>
          <Form.Item name="Name" label={"Name"}>
            <Input placeholder={"Search By Candidte Name"} />
          </Form.Item>
          <Form.Item name="Nationality" label={"Nationality"}>
            <Select placeholder={"Nationality"} options={nation} allowClear />
          </Form.Item>
          <Form.Item name="dob" label={"Date of Birth"}>
            <DatePicker defaultValue={null} format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item name="PositionAppliedFor" label={"Position Applied For"}>
            <Input placeholder={"Position Applied For"} />
          </Form.Item>
          <Form.Item name="MaritalStatus" label={"Marital Status"}>
            <Select
              placeholder={"Please Select Marital Status"}
              options={MaritalStatus}
              allowClear
            />
          </Form.Item>
          <Form.Item name="Gender" label={"Gender"}>
            <Select
              placeholder={"Please Select Gender"}
              options={gender}
              allowClear
            />
          </Form.Item>
          <Form.Item name="Status" label={"Status"}>
            <Select placeholder={"Please Status"} options={status} allowClear />
          </Form.Item>
        </div>
        <Divider />
        <div className="flex-at-end">
          <Button
            className=""
            type="text"
            onClick={() => {
              toggleFilterModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className=""
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Search
          </Button>
        </div>
      </Form>
    </m.div>
  );
};

export default RecruitmentTrackerFilter;
